(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nm-shop-the-look"] && !Shopify.designMode) return;
  try {
    function nmInitLookbook(root){
 if(!root||root.dataset.ready==='true')return;
 root.dataset.ready='true';
 const track=root.querySelector('[data-look-track]');
 const arrows=Array.from(root.querySelectorAll('[data-look-scroll]'));
 function updateArrows(){
  const max=Math.max(0,track.scrollWidth-track.clientWidth);
  arrows.forEach(button=>button.disabled=max<2||(Number(button.dataset.lookScroll)<0?track.scrollLeft<2:track.scrollLeft>=max-2));
 }
 arrows.forEach(button=>button.addEventListener('click',()=>{
  const card=track.firstElementChild;
  if(!card)return;
  const step=card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0);
  const count=Math.max(1,Math.floor((track.clientWidth+12)/step));
  track.scrollTo({left:track.scrollLeft+Number(button.dataset.lookScroll)*step*count,behavior:'smooth'});
 }));
 root.addEventListener('click',event=>{
  const opener=event.target.closest('[data-look-open]');
  if(opener&&root.contains(opener)){const dialog=document.getElementById(opener.dataset.lookOpen);if(dialog&&!dialog.open)dialog.showModal();}
  const closer=event.target.closest('[data-look-close]');
  if(closer)closer.closest('dialog').close();
 });
 root.querySelectorAll('.nm-look-dialog').forEach(dialog=>dialog.addEventListener('click',event=>{
  if(event.target!==dialog)return;
  const rect=dialog.getBoundingClientRect();
  if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
 }));
 track.addEventListener('scroll',updateArrows,{passive:true});
 if(typeof ResizeObserver!=='undefined')new ResizeObserver(updateArrows).observe(track);
 updateArrows();
}
function nmBootLooks(){document.querySelectorAll('[data-lookbook]').forEach(nmInitLookbook);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',nmBootLooks,{once:true});else nmBootLooks();
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lookbook]').forEach(nmInitLookbook));
  } catch(e) { console.error(e); }
})();

})();
